import React from 'react';
import { Pagination, useListPaginationContext, useTranslate, } from 'react-admin';
import { Button, Toolbar, 
/* tree-shaking no-side-effects-when-called */ makeStyles, useTheme, } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
const useStyles = makeStyles({
    spacer: {
        flex: '1 1 100%',
    },
});
const CustomPagination = (props) => {
    const { page, total, setPage } = useListPaginationContext(props);
    const classes = useStyles(props);
    const theme = useTheme();
    const translate = useTranslate();
    if (total >= 0) {
        return React.createElement(Pagination, Object.assign({}, props));
    }
    return (React.createElement(Toolbar, null,
        React.createElement("div", { className: classes.spacer }),
        page > 1 && (React.createElement(Button, { color: "primary", key: "prev", onClick: () => {
                setPage(page - 1);
            } },
            theme.direction === 'rtl' ? React.createElement(ChevronRight, null) : React.createElement(ChevronLeft, null),
            translate('ra.navigation.prev'))),
        total < -1 && (React.createElement(Button, { color: "primary", key: "next", onClick: () => {
                setPage(page + 1);
            } },
            translate('ra.navigation.next'),
            theme.direction === 'rtl' ? React.createElement(ChevronLeft, null) : React.createElement(ChevronRight, null)))));
};
export default CustomPagination;
//# sourceMappingURL=Pagination.js.map